import React, {FC} from "react";
import {
    IconButton,
    Tooltip,
} from "@mui/material";
import FavoriteIcon from "@mui/icons-material/Favorite";
import {IdlocaGeneric} from "../../locales/IdlocaGeneric";
import {Locale} from "../../locales/Locale";

interface IAddToFavoritesButton {
    onClick: () => void;
    isFavourite: boolean;
    mobileMode: boolean;
}

export const AddToFavoritesButton: FC<IAddToFavoritesButton> = ({onClick, isFavourite, mobileMode}) => {
    const toolTipTitle = isFavourite ?
        <Locale localeId={IdlocaGeneric.remove_from_favourites}/> :
        <Locale localeId={IdlocaGeneric.add_to_favourites}/>;
    return (
        <Tooltip title={toolTipTitle}
            arrow>
            <IconButton
                color={isFavourite ? "error" : "default"}
                onClick={onClick}
                aria-label={"add to favourites"}
                sx={{
                    transition: "opacity 0.3s, transform 0.3s",
                    opacity: mobileMode ? 1 : 0,
                    transform: mobileMode ? "translateY(0)" : "translateY(-10px)",
                }}
            >
                <FavoriteIcon/>
            </IconButton>
        </Tooltip>
    );
};
